import { render, staticRenderFns } from "./index.vue?vue&type=template&id=663235a0&scoped=true&"
import script from "./index.vue?vue&type=script&charset=utf-8&lang=js&"
export * from "./index.vue?vue&type=script&charset=utf-8&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=663235a0&lang=scss&rel=stylesheet%2Fsass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663235a0",
  null
  
)

export default component.exports